import { log } from 'sonarqube-scanner/src/logging';
import { DATA } from '../constants/titleAndMetaDescription';
import {useFeatureIsOn, useFeatureValue, useFeature, useGrowthBook} from "@growthbook/growthbook-react";

const DEFAULT_ROUTE = "defaultRoute";

export default (route = DEFAULT_ROUTE) => {
    
    let titleMetadata =  useFeatureValue('title-metadata',DATA)
    const data = titleMetadata[route];
    return data ?? titleMetadata[DEFAULT_ROUTE];
};